import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ModuloRiordinoService } from 'src/app/shared/services/modulo-riordino.service';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-modulo-riordino',
  templateUrl: './modulo-riordino.component.html',
  styleUrls: ['./modulo-riordino.component.css'],
  imports: [
    DxDataGridComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxoLookupComponent,
  ],
  standalone: true,
})
export class ModuloRiordinoComponent implements OnInit {
  listTipiArticoli: any;
  dataSource: any;

  private tipiArticoliService = inject(TipiArticoliService);
  private modRioService = inject(ModuloRiordinoService);

  ngOnInit() {
    this.loadLookups();
    this.loadData();
  }

  loadLookups() {
    this.tipiArticoliService.getListTipiArticoliTemp(false).subscribe({
      next: (res) => {
        this.listTipiArticoli = {
          store: {
            type: 'array',
            data: res.sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1)),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        if (error?.error?.text) {
          const errT = error?.error?.text();
          const errj = JSON.parse(errT);
          notify(errj?.title, 'warning', 3000);
        } else {
          notify('Errore caricamento tipi articoli', 'error', 3000);
        }
      },
    });
  }

  loadData() {
    this.dataSource = new CustomStore({
      key: 'idTipologia',
      load: () => {
        return firstValueFrom(this.modRioService.list())
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        return firstValueFrom(this.modRioService.insert(values)).catch(() => {
          throw 'Insertion failed';
        });
      },
      remove: (key) => {
        console.log(key);
        return (
          firstValueFrom(this.modRioService.remove(key))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              console.log(error.error.title);
              throw error.error.title;
            })
        );
      },
      update: (key, values) => {
        return firstValueFrom(this.modRioService.update(key, values)).catch(
          (error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Update failed';
            }
          },
        );
      },
    });
  }

  onUpdating(e) {
    e.newData = Object.assign(e.oldData, e.newData);
  }
}
